import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { type Formatter } from 'react-timeago'

import dayjs from 'dayjs'

export const useTimeAgoFormatter = () => {
  const intl = useIntl()
  return useCallback<Formatter>(
    (value, unit, _suffix, then, _defaut, now) => {
      if (unit === 'hour' && value < 12) {
        const numberOfMinutes = dayjs(now()).diff(then, 'minute')
        return intl.formatMessage({ id: 'time.value.minute' }, { value: numberOfMinutes })
      }
      return intl.formatMessage({ id: `time.value.${unit}` }, { value })
    },
    [intl]
  )
}

export const useWillExecuteInTimeAgoFormatter = () => {
  const intl = useIntl()
  return useCallback<Formatter>(
    (value, unit, suffix, then, _defaut, now) => {
      if (unit === 'second' || suffix === 'ago') {
        return intl.formatMessage({ id: 'requestList.willExecuteAt.now' })
      }
      if (unit === 'minute' && value <= 3) {
        return intl.formatMessage({ id: 'requestList.willExecuteAt.soon' })
      }
      let time = ''
      if (unit === 'hour' && value < 12) {
        const numberOfMinutes = dayjs(now()).diff(then, 'minute')
        time = intl.formatMessage({ id: 'time.value.minute' }, { value: numberOfMinutes })
      } else {
        time = intl.formatMessage({ id: `time.value.${unit}` }, { value })
      }
      return intl.formatMessage({ id: 'requestList.willExecuteAt.prefix' }, { time })
    },
    [intl]
  )
}
